<template>
	<el-container>
		<div id="index">
      <div class="index_rigth">
        <span class="index_rigth_span" style="height: 40px;line-height: 40px;
        vertical-align: middle;font-size: 16px;background: #1243CB;color: #ffffff;">扫码加入</span>
        <div style="margin-top: 20px;">
          <img style="width: 120px;height: 120px;" :src="baseUrl+this.dwewm.fjlj"/>
          <span class="index_rigth_span">中国消防协会</span>
          <span class="index_rigth_span">单位会员群</span>
        </div>
        <div style="margin-top: 15px;">
          <img style="width: 120px;height: 120px;" :src="baseUrl+this.grewm.fjlj"/>
          <span class="index_rigth_span">中国消防协会</span>
          <span class="index_rigth_span">个人会员群</span>
        </div>
      </div>
			<el-header>
				<Header></Header>
			</el-header>
			<div class="lmdiv">
				<nav class="nav">
					<el-menu :default-active="onRoutes" class="el-menu-demo headmenufixed lm" mode="horizontal" background-color="#fff"
					 router>
						<el-menu-item :style="{width: dhwidth + 'px'}" v-for="item1 in parMenus" :key="item1.lmid" :index='item1.lmdz'>
              <i :class="getMenuIcon(item1.icon)"></i>
              <span>&nbsp;{{item1.lmmc}}</span>
						</el-menu-item>
						<!--
            <el-menu-item v-for="item1 in parMenus" :key="item1.lmid" v-if='!item1.children || item1.children && item1.children.length<=0'
						 :index='item1.lmdz'>
							<div><i :class="getMenuIcon(item1.icon)" style="color: #fff;"></i>&nbsp;{{item1.lmmc}}</div>
						</el-menu-item>
						<el-submenu v-else :index="item1.lmid">
							<template slot="title">
								<div><i :class="getMenuIcon(item1.icon)" style="color: #fff;"></i>
									&nbsp;{{item1.lmmc}}</div>
							</template>
							<el-menu-item class="m" v-for="item2 in item1.children" :key="item2.lmid" v-if='!item2.children || item2.children && item2.children.length<=0'
							 :index="item2.lmid">
								<div><i style="margin-bottom: 5px; color: rgb(77, 157, 209);" class="el-icon-caret-right"></i>{{item2.lmmc}}</div>
							</el-menu-item>
							<el-submenu v-else :index="item2.lmid">
								<template slot="title">
									<div>{{item2.lmmc}}</div>
								</template>
								<el-menu-item v-for="item3 in item2.children" :key="item3.lmid" :index="item3.lmid">
									<div>{{item3.lmmc}}</div>
								</el-menu-item>
							</el-submenu>
						</el-submenu>
            -->
					</el-menu>
				</nav>
			</div>
      <!-- <tip id="tip"  v-show="searchVal.showView" :json="json" @closeView="closeView"></tip> -->
			<el-container>
				<div class="content">
					<Breadcrumb class="breadcrumb" v-if="hasBread"></Breadcrumb>
					<transition name="move" mode="out-in">
						<div class="content-body mini-scroller">
							<keep-alive>
								<router-view v-if="$route.meta.keepAlive"></router-view>
							</keep-alive>
							<router-view v-if="!$route.meta.keepAlive"></router-view>
						</div>
					</transition>
				</div>
			</el-container>
			<el-footer>
				<Footer></Footer>
			</el-footer>
		</div>
	</el-container>
</template>

<script>
	//引入Header Component
	import Header from '@/views/portal/layout/Header'
	//引入Footer Component
	import Footer from '@/views/portal/layout/Footer'
	//引入面包屑Breadcrumb
	import Breadcrumb from '@/components/breadcrumb'

  import tip from '@/components/tip'
	export default {
		components: {
			Footer,
			Header,
			Breadcrumb,
      tip
		},
		data() {
			return {
				currentUser: JSON.parse(localStorage.getItem('CURRENTUSER')),
				parMenus: [],
				subMenus: [],
				current: 0,
				load: false,
				loading: false,
				collapse: false,
				hasBread: false,
				asideWith: "240px",
				activeIndex2: '0',
				activeIndex3: '0',
        json: {
        	// url: 'http://61.161.226.213:8881/#/',
        	left: 100,
        	top: 400,
        	directionX: 1,
        	directionY: 1,
        	distance: null,
        	interval: null,
        	target: "_blank",
        	zIndex: null,
        	width: null,
        	height: null,
        	noHoverPause: null, //鼠标经过时不停止，为true时不停止
        	cursor: null,
        	imgurl: "../../../static/images/portal/tip.png"
        },
        searchVal: {
        	showView: false,
        },
        dhwidth:0,
        baseUrl: window.config.baseUrl + "/upload/",
        dwewm: {},
        grewm: {},
			}
		},
    //监听路由变化
    watch: {
    	'$route.path': function(newVal, oldVal) {
    		if (newVal != "/home") {
    			this.searchVal.showView = false

    		} else {
    			this.searchVal.showView = true
    		}
    		// this.insertVisit(newVal);
    	}
    },
		beforeCreate() {
			//初始化菜单
			let vm = this;
			vm.$axios.get("/portal/lm/column/getAll?isPortal=true").then(function(res) {
				let menus = []
				res.data.result.forEach(e => {
					menus.push(e)
				});
				vm.parMenus = menus;
        vm.dhwidth = 1200 / vm.parMenus.length
				vm.subMenus = res.data.result[0].children;
				//判断当前哪个菜单选中 by li.xue 2020/12/31
				for (var i in vm.parMenus) {
					if (vm.$route.path == vm.parMenus[i].lmdz) {
						vm.current = i;
						break;
					}
				}
			}.bind(this), function(error) {
				console.log(error);
			});
		},
		computed: {
			onRoutes() {
				var routePath = this.$route.path;
        if(this.$route.path == "/home"){
          this.searchVal.showView = true
        }
				//首页不要面包屑，其他页面需要面包屑
				for (var i in this.parMenus) {
					if (routePath == this.parMenus[i].lmdz || "/meeting" == routePath) {
						this.hasBread = false;
						break;
					} else {
						this.hasBread = true;
					}
				}
				// if(this.$route.path == '/home') {
				//   this.hasBread = false;
				// }else {
				//   this.hasBread = true;
				// }
				if (this.$route.matched.length > 3) {
					routePath = this.$route.matched[2].path;
				} else if (this.$route.matched.length == 3 && !this.$route.matched[2].path.endsWith('/')) {
					routePath = this.$route.matched[1].path;
				}
				if (routePath.endsWith('/')) {
					routePath = routePath.substr(0, routePath.length - 1);
				}
				for (var i in this.parMenus) {
					if (routePath == this.parMenus[i].lmdz) {
						this.subMenus = this.parMenus[i].children;

						return routePath;
					} else {
						if (this.parMenus[i].children != null) {
							for (var j in this.parMenus[i].children) {
								if (routePath == this.parMenus[i].children[j].lmdz) {
									this.subMenus = this.parMenus[i].children;
									return this.parMenus[i].lmdz;
								} else {
									if (this.parMenus[i].children[j].children != null) {
										for (var k in this.parMenus[i].children[j].children) {
											if (routePath == this.parMenus[i].children[j].children[k].lmdz) {
												this.subMenus = this.parMenus[i].children;
												return this.parMenus[i].lmdz;
											}
										}
									}
								}
							}
						}
					}
				}
			},
		},
    created() {
      this.getDetail()
    },

		methods: {
      closeView: function() {
      	this.searchVal.showView = false;
      },
			//获取菜单图标
			getMenuIcon(value) {
				return "iconfont " + value;
			},

			//路由跳转
			navClick(index) {
				this.current = index;
			},

			//打开子菜单
			openSubMenu(index, indexPath) {
				/** 二级栏目
				for (var i in this.parMenus) {
					if (index == this.parMenus[i].lmdz) {
						this.subMenus = this.parMenus[i].children;
						break;
					}
				}
				if (this.subMenus == null || this.subMenus.length == 0) {
					this.$router.push({
						path: index
					});
				} else {
					if (this.subMenus[0].children == null) {
						this.$router.push({
							path: this.subMenus[0].lmdz
						});
					} else {
						this.$router.push({
							path: this.subMenus[0].children[0].lmdz
						});
					}
        }
         */
			},
      getDetail:function(){
        let vm= this
        vm.loading = true
        var params = {}
        vm.$axios.post("portal/ewm/list", params).then(
          function(res) {
            if (res.data.code == "00000000") {
                if(res.data.result.length > 0){
                  for(let i in res.data.result){
                    if(res.data.result[i].hylx == "10"){
                      vm.dwewm = res.data.result[i]
                    }else if(res.data.result[i].hylx == "20"){
                      vm.grewm = res.data.result[i]
                    }

                  }
                }
                vm.loading = false;
            }
          }.bind(this),
          function(error) {
            vm.loading = false;
          }
        );
      }
		},
	};
</script>
<style lang="scss">
	#index {
		min-width: 1300px;
		background-color: #EFF6FD;

    .index_rigth{
      // position: absolute;
      position: fixed;
      right: 0;
      top:25%;
      // margin-right: 3%;
      background: #FFFFFF;
      width: 160px;
      text-align: center;
      padding-bottom: 20px;
    }

    .index_rigth_span{
      display: block;
      width: 100%;
      text-align: center;
      color: #1243CB;
      font-size: 16px;
    }

		.el-header {
			padding: 0 !important;
			height: 160px !important;
			flex-shrink: 0;
		}

		.el-footer {
			background-color: #EFF6FD;
			padding: 0 !important;
			color: #ffffff;
			// height: 300px;
		}

		.el-main {
			padding: 0 !important;
			font-size: 14px;
		}

		.lmdiv {
			width: 100%;
			background-color: #FFFFFF;
		}

		.nav {
			width: calc(100vw - 17px);
		}

		.lm {
			margin: 0 auto;
			width: 1200px;
			text-align: center;
			font-size: 18px;
		}

		.el-menu-item {
			// width: 171px;
			font-size: 18px;
		}

		.el-submenu {
			// width: 171px;
			font-size: 18px;
		}

		.el-menu-item {
			color: #333333;
		}

		.el-menu--horizontal .el-menu-item.is-active {
			color: #0a308f;
			border-bottom: 2px solid #0a308f;
		}

		.breadcrumb {
			width: 1200px;
			height: 0.6rem;
			margin: 0 auto;
			margin-top: 20px;
			font-size: 14px;
		}
    .content-body {
      padding-top: 30px;
      padding-bottom: 30px;
    }
    .nav .iconfont{
      font-size: 18px;
    }
	}
</style>



// WEBPACK FOOTER //
// src/views/portal/layout/Index.vue